
export default {
  name: "DialogUserEditESOMember",
  props: {
    visible: Boolean,
    editedItem: {
      type: Object, default: () => ({
        role: ""
      })
    }
  },
  computed: {
    dialogTitle() {
      return this.$t("user.profile.startup.edit_member") || ""
    },
  },
  methods: {
    closeDialog() {
      this.$emit("update:visible", false);
    },
    submit() {
      if (!this.$refs.editedForm.validate()) return;
      this.$emit("save", this.editedItem);
    },
  },
}
